import axios from 'axios';
import * as types from './AdminUsers.types';
import { showNotification, empty } from './../../utils';
import * as loginActions from './../Login/Login.actions';
import * as selectors from './AdminUsers.selectors';
import * as dialog from './../common/dialog';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchUsers = () => (dispatch, getState) => {
    const pagination = selectors.getPagination(getState());
    const sort = selectors.getSort(getState());
    const search = selectors.getSearch(getState());
    const searchType = selectors.getSearchType(getState());

    let params = [];
    params.push('active-page=' + pagination.activePage);
    params.push('elements-per-page=' + pagination.elementsPerPage);
    params.push('sort-column=' + sort.column);
    params.push('sort-type=' + sort.type);
    params.push('search=' + search);
    params.push('search-type=' + searchType);

    dispatch({ type: types.FETCH_USERS, payload: null });
    axios.get(apiUrl + '/user/uth-admin-index?' + (params.length === 0 ? '' : '&' + params.join('&')),
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_USERS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_USERS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const saveUser = () => (dispatch, getState) => {
    const fields = selectors.getFields(getState());
    const permissions = selectors.getPermissions(getState());

    if (empty(fields.name)) {
        return showNotification('Complete information', 'Enter the Name', 'info');
    }
    if (empty(fields.email)) {
        return showNotification('Complete information', 'Enter the Email', 'info');
    }

    if (!fields.id) {
        if (empty(fields.new_password)) {
            showNotification('Complete Information', 'Enter the New Password', 'info');
            return false;
        }
        if (empty(fields.confirm_password)) {
            showNotification('Complete Information', 'Enter the Confirm New Password', 'info');
            return false;
        }
    }

    if (!empty(fields.new_password) || !empty(fields.confirm_password)) {
        if (empty(fields.new_password)) {
            showNotification('Complete Information', 'Enter the New Password', 'info');
            return false;
        }
        if (empty(fields.confirm_password)) {
            showNotification('Complete Information', 'Enter the Confirm New Password', 'info');
            return false;
        }
        if (fields.new_password !== fields.confirm_password) {
            showNotification('Complete Information', 'The New Password and Confirm New Password are different', 'info');
            return false;
        }
    }

    let endpoint = null;
    if (fields.id && fields.id !== '') {
        endpoint = apiUrl + '/user/uth-update';
    } else {
        endpoint = apiUrl + '/user/uth-create';
    }

    dispatch({ type: types.SAVE_USER, payload: null });
    axios.post(endpoint, { fields, permissions },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.SAVE_USER_SUCCESS, payload: response.data });
            dispatch(dialog.actions.hideDialog('form-modal'));
            showNotification('Item Saved', 'The item has been saved successfully', 'success');
            dispatch(fetchUsers());
            dispatch(setFields({}));
            dispatch(setPermissions('[]'));
        })
        .catch((error) => {
            dispatch({ type: types.SAVE_USER_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const deleteUser = () => (dispatch, getState) => {
    const idModal = selectors.getIdModal(getState());

    dispatch({ type: types.DELETE_USER, payload: null });
    axios.delete(apiUrl + '/user/uth-delete?id=' + idModal,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.DELETE_USER_SUCCESS, payload: response.data });
            dispatch(dialog.actions.hideDialog('delete-modal'));
            showNotification('Item Deleted', 'The item has been deleted successfully', 'success');
            dispatch(fetchUsers());
        })
        .catch((error) => {
            dispatch({ type: types.DELETE_USER_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const setIdModal = (id) => (dispatch) => {
    dispatch({
        type: types.SET_ID_MODAL,
        payload: id
    });
}

export const setActivePage = (value) => (dispatch, getState) => {
    new Promise(resolve => {
        dispatch({
            type: types.SET_ACTIVE_PAGE,
            payload: value,
        });
        resolve();
    }).then(() => {
        dispatch(fetchUsers());
    });
}

export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}

export const setField = (field, value) => (dispatch) => {
    dispatch({
        type: types.SET_FIELD,
        payload: { field, value },
    })
}

export const setSort = (column, type) => (dispatch) => {
    new Promise(resolve => {
        dispatch({
            type: types.SET_SORT,
            payload: { column, type }
        });
        resolve();
    }).then(() => {
        dispatch(fetchUsers());
    });
}

export const setSearch = (value) => dispatch => {
    dispatch({
        type: types.SET_SEARCH,
        payload: value,
    });
}

export const setSearchType = (value) => dispatch => {
    dispatch({
        type: types.SET_SEARCH_TYPE,
        payload: value,
    });
}

export const setPermissions = (value) => dispatch => {
    dispatch({
        type: types.SET_PERMISSIONS,
        payload: value,
    });
}

export const addPermission = (value) => dispatch => {
    dispatch({
        type: types.ADD_PERMISSION,
        payload: value,
    });
}

export const removePermission = (value) => dispatch => {
    dispatch({
        type: types.REMOVE_PERMISSION,
        payload: value,
    });
}

export const setFields = (value) => dispatch => {
    dispatch({
        type: types.SET_FIELDS,
        payload: value,
    });
}